import React, { useEffect } from 'react'
import { faHome} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import logo from '../assets/images/logo-t.png'
import '../assets/css/error.css'
import { Link } from 'react-router-dom'

const Error = () => {
    useEffect(() => {
        document.title = 'Pouch | Not Found'
    }, [])
    return (
        <>
            <div className="body bg-dark">
                <div className="hero d-flex align-items-center justify-content-center">
                    <section className="p-4 text-center">
                        <p className="h1 display-2 text-white" style={{fontWeight : 'bolder', fontFamily : 'cursive'}}>
                            4<img alt="pouch" src={logo} style={{width : '80px'}} />4 
                        </p>       
                        <h5 className="text-white">Oops! You’ve got lost in pouch</h5>
                        <Link to="/" className="btn ebutton text-white mt-3 mb-5 mb-lg-2">Back to Home <FontAwesomeIcon icon={faHome} /></Link>
                    </section>
                </div>
            </div>
        </>
    )
}

export default Error


